export default "__VITE_ASSET__Br7yqhKJ__"